import React from "react";
import Link from "next/link";
import { CircleUser } from "lucide-react";

export default function BtnAccount() {
  return (
    <a
      href={"/profile"}
      className="flex items-center hover:text-blue-700"
    >
      <CircleUser />
    </a>
  );
}